import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowRightOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m21.129 11.25-8.266-8.266a.75.75 0 1 1 1.06-1.06L24 12 13.924 22.076a.75.75 0 1 1-1.06-1.06l8.265-8.266H.75a.75.75 0 0 1 0-1.5z" /></svg>
);
